module.exports = __webpack_public_path__ + "static/img/introduction-cake.18bf82f2.png";